
import { UseFormReturn } from "react-hook-form";
import { ProcurementFormValues } from "../schema";
import { ItemsHeader } from "./ItemsHeader";
import { ItemsEmptyState } from "./ItemsEmptyState";
import { ItemCard } from "./ItemCard";
import { ItemsTotal } from "./ItemsTotal";

interface ItemsFieldProps {
  form: UseFormReturn<ProcurementFormValues>;
  subtotal?: number;
}

export const ItemsField = ({ form, subtotal }: ItemsFieldProps) => {
  const items = form.watch("items") || [];

  const addItem = () => {
    const currentItems = form.getValues("items") || [];
    form.setValue("items", [
      ...currentItems,
      {
        product_id: "",
        product_name: "",
        unit_of_measure: "kg",
        price_per_unit: 0,
        quantity: 0,
        quality_grade: "",
        notes: ""
      }
    ]);
  };

  const removeItem = (index: number) => {
    const currentItems = form.getValues("items") || [];
    const newItems = currentItems.filter((_, i) => i !== index);
    form.setValue("items", newItems);
  };

  return (
    <div className="space-y-4">
      <ItemsHeader onAddItem={addItem} />

      {items.length === 0 && <ItemsEmptyState />}

      {items.map((item, index) => (
        <ItemCard
          key={index}
          form={form}
          index={index}
          item={item}
          itemsCount={items.length}
          onRemoveItem={removeItem}
        />
      ))}

      {items.length > 0 && (
        <ItemsTotal totalAmount={subtotal || 0} />
      )}
    </div>
  );
};
